import {
  Injectable,
  signal,
} from '@angular/core';
import { BaseGatewayService } from '../ws/base-gateway.service';
import { FindNotificationsUnreadCountResponseDto } from './dtos/find-notifications-unread-count.dto';

@Injectable({ providedIn: 'root' })
export class NotificationGatewayService extends BaseGatewayService {
  protected override namespace = 'notifications';

  #unreadCount = signal(0);
  unreadCount = this.#unreadCount.asReadonly();

  override disconnect() {
    this.#unreadCount.set(0);
    super.disconnect();
  }

  subscribeToNotificationsUnreadCount(userId: number) {
    if (!this.socket?.connected) {
      this.connect();
    }

    const socket = this.socket;
    if (!socket) return;

    if (userId == null) return;

    socket.off('notificationsUnreadCount');

    socket.emit('subscribeToNotificationsUnreadCount');

    socket.on(
      'notificationsUnreadCount',
      (data: FindNotificationsUnreadCountResponseDto) => {
        console.debug(
          `Received unread count of user with ID ${userId} from server`,
          data
        );
        this.#unreadCount.set(data.unreadCount);
      }
    );
  }
}
